// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./DaxlinePro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./DaxlinePro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "DaxlinePro";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
	font-weight: 400;
	font-style: normal;
}

@font-face {
	font-family: "DaxlinePro";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
	font-weight: 700;
	font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/fonts/fonts.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,+DAAuD;CACvD,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,+DAAoD;CACpD,gBAAgB;CAChB,kBAAkB;AACnB","sourcesContent":["@font-face {\n\tfont-family: \"DaxlinePro\";\n\tsrc: url(\"./DaxlinePro-Regular.ttf\") format(\"truetype\");\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"DaxlinePro\";\n\tsrc: url(\"./DaxlinePro-Bold.ttf\") format(\"truetype\");\n\tfont-weight: 700;\n\tfont-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
